import { render, staticRenderFns } from "./m-offline-badge.vue?vue&type=template&id=452f12b6&scoped=true&"
import script from "./m-offline-badge.vue?vue&type=script&lang=js&"
export * from "./m-offline-badge.vue?vue&type=script&lang=js&"
import style0 from "./m-offline-badge.vue?vue&type=style&index=0&id=452f12b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452f12b6",
  null
  
)

export default component.exports